// Hợp đồng
export default {
  General: 2, // không chọn
  Purchase: 0, // 'Hợp đồng mua',
  Sale: 1, // 'Hợp đồng bán',
};
